import React, { useState } from 'react'
import { TransportTypeManager } from '@/shared/ui'
import { 
  useTransportTypesList, 
  useCreateTransportType, 
  useUpdateTransportType, 
  useDeleteTransportType,
  usePagination 
} from '@/shared/hooks'
import type { TransportTypeCreateRequest, TransportTypeUpdateRequest } from '@/shared/api/types'

export const TransportTypesPage: React.FC = () => {
  const [search, setSearch] = useState('')
  const { page, limit, setPage } = usePagination()
  
  const { data, isLoading, error } = useTransportTypesList({
    page,
    limit,
    search: search || undefined,
    include_inactive: false
  })
  
  const createTransportType = useCreateTransportType()
  const updateTransportType = useUpdateTransportType()
  const deleteTransportType = useDeleteTransportType()

  const handleCreate = (
    name: string, 
    isActive?: boolean, 
    sortOrder?: number, 
    requiresLicense?: boolean
  ) => {
    const request: TransportTypeCreateRequest = {
      name,
      is_active: isActive,
      sort_order: sortOrder,
      requires_license: requiresLicense
    }
    createTransportType.mutate(request)
  }

  const handleUpdate = (
    id: number, 
    name?: string, 
    isActive?: boolean, 
    sortOrder?: number, 
    requiresLicense?: boolean
  ) => {
    const request: TransportTypeUpdateRequest = {
      name,
      is_active: isActive,
      sort_order: sortOrder,
      requires_license: requiresLicense
    }
    updateTransportType.mutate({ id, request })
  }

  const handleDelete = (id: number) => {
    deleteTransportType.mutate(id)
  }

  return (
    <TransportTypeManager
      title="Виды транспорта"
      description="Управление видами транспорта для курьеров"
      data={data?.items || []}
      loading={isLoading}
      error={error}
      includeInactive={false}
      onToggleInactive={undefined}
      onCreate={handleCreate}
      onUpdate={handleUpdate}
      onDelete={handleDelete}
      isCreating={createTransportType.isPending}
      isUpdating={updateTransportType.isPending}
      isDeleting={deleteTransportType.isPending}
    />
  )
}
